import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import ReactGA from "react-ga4";
import "./SignUpLogin.css";
import {
  Form,
  Input,
  Button,
  Tooltip,
  message,
} from "antd";
import "antd/dist/antd.css";
import { LoadingOutlined } from "@ant-design/icons";
import { useHistory } from "react-router-dom";
import { Auth } from "../../../config/aws-exports";
import {
  checkEmailFlow,
  checkUsernameUnique,
  fetchExistingtUser,
  sendEmailVerification,
  userClicked,
} from "../../../redux/actions";
import Infomessage from "../../../components/Infomessage";
import GreenCheck from "../../../assets/icons/typcn_tick.svg";
import { GoAlert } from "react-icons/go";
import { debounce, setCookie } from "../../../shared/helpers";
import useCurrentIP from "../../../components/Hooks/currentIp";
import { APP_NAME, EVENTS, PAGE, PAGE_TYPE } from "../../../../../../packages/skillgigs-employer-web-app/src/constants/userTrackingConstants";
const SignUp = (props) => {
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const getRememberMe = JSON.parse(localStorage.getItem("RememberMe"));
  let InitialValue = !getRememberMe ? false : getRememberMe;
  // const [passwordValidation, setPasswordValidation] = useState(false);
  const signUpLogin = useSelector((state) => state.authReducer.signUpLogin);
  const uuid = useSelector((state) => state.userTrackingReducer.uuid);
  const [userEmail, setUserEmail] = useState(null);
  const [count, setCount] = useState(false);
  const [checkEmail, setCheckEmail] = useState(false);
  const [check, setCheck] = useState(false);
  const [greenCheck, setGreenCheck] = useState(false);
  const [greenCheckUserName, setGreenCheckUserName] = useState(false);
  const [greenCheckPassword, setGreenCheckPassword] = useState(false);
  const [showCheckPassword, setShowCheckPassword] = useState(false);
  const [showCheckIconUserName, setShowCheckIconUserName] = useState(false);
  const [showCheckIconEmail, setShowCheckIconEmail] = useState(false);
  const [errormessage, setErrorMessage] = useState("");
  const emailValidation = useSelector((state) => state.chekckUserReducer.user);
  const checkUserLoading = useSelector((state) => state.chekckUserReducer.loading);
  const NotValid = useSelector((state) => state.checkUserNameReducer.valid);
  const CheckUserNameLoading = useSelector((state) => state.checkUserNameReducer.UN_Loading);
  const [validUserNameCheck, setValidUserNameCheck] = useState(null)
  const [clickCount, setClickCont] = useState(1);
  const [emailss, setEmailss] = useState("");
  const [isremember, setIsRemember] = useState(InitialValue);
  // Controlled Values
  const [email, setEmail] = useState(null);
  const [passwordInp, setPasswordInp] = useState(null);
  // const [count, setCount] = useState(false);
  const [loading, setLoading] = useState(false);
  // const [messagetype, setMessageType] = useState("container-error");
  const ipaddress = useCurrentIP()
  console.log('ip address in signup', ipaddress)
  const clicked = () => {
    setCheck(!check);
  };
  const textemail = <span>example: example@mail.com</span>;
  const textpass = <span>Minimum 8 characters required</span>;
  const buttonWidth = 70;
  const history = useHistory();
  const [mode, setMode] = useState("Login");
  const [errormsg, setErrormsg] = useState("");
  const SwitchMode = (key) => {
    setMode(key);
  };

  
  const checkUserName = useSelector(
    (state) => state.checkUserNameReducer.valid
  );
  const validateEmail = (e) => {
    const email = e.target.value;
    setCount(false);
    setEmail(email);
    const v2 = 
    // /^\S*$/;
    /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
    const valid =
      // /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
    if (email.length > 0) {
      setShowCheckIconEmail(true);
    }
    else if (email == undefined || email == null || email.length < 1) {
      setGreenCheck(false);
      setShowCheckIconEmail(true)
    }
    if (valid.test(email) && v2.test(email)) {
      setGreenCheck(true);
    } else {
      setGreenCheck(false);
    }
  };
  const validateUserName = (e) => {
    const name = e.target.value;
    const valid = /^.{3,20}$/;
    const userName = name.toLowerCase()
    dispatch(checkUsernameUnique(userName));
    // const valid = /^([a-zA-Z]{3,})+\s+([a-zA-Z]{3,})+$/;
    if (name.length > 0 && name.length < 3) {
      setErrormsg("Username not valid, please enter more than 3 characters.");
    }
    if (name.length > 20) {
      setErrormsg("Username not valid, please enter less than 20 characters.");
    }
    if (name.length > 0) {
      setShowCheckIconUserName(true);
    }
    if (valid.test(name)) {
      setGreenCheckUserName(true);
    } else {
      setGreenCheckUserName(false);
    }
  };
  const validatePassword = (e) => {
    setPasswordInp(e.target.value);
    const password = e.target.value;
    const v2 = /^\S{8,}$/;
    const valid = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9]).{8,}$/;
    if (password.length > 0) {
      setShowCheckPassword(true);
    }
    if (valid.test(password) && v2.test(password)) {
      setGreenCheckPassword(true);
    } else {
      setGreenCheckPassword(false);
    }
  };
  const onLogin = async ({ email, password }) => {
    localStorage.setItem("Email", email);
    dispatch(sendEmailVerification());
    // localStorage.setItem("password", password);
    setCount(false);
    setLoading(true);
    try {
      const response = await Auth.signIn({ username: email, password });
      // https://serverless-idm.awssecworkshops.com/01-user-auth/#validate-sign-up-and-sign-in
      const session = await Auth.currentSession();
      // console.log('Cognito User Access Token:', session.getAccessToken().getJwtToken());
      if (isremember) {
        const result = await Auth.rememberDevice();
        if (result == "SUCCESS") {
          setCookie("RememberMe", "true");
        }
      }
      // console.log('Cognito User Refresh Token', session.getRefreshToken().getToken());
      setLoading(false);
      // history.push("/auth");
      window.location.replace("/employer/auth")
    } catch (error) {
      setLoading(false);
      setCount(true);
      // message.error(error.message);
      // setPasswordValidation(true);
      setTimeout(() => {
        setCount(false);
      }, 4000);
      if (isremember) {
      }
    }
  };
  const emailSave = ({ email, password }) => {
    var premail = email.toString().toLowerCase();
    // dispatch(checkEmailFlow(true));
    dispatch(fetchExistingtUser(premail));
    setUserEmail(premail);
    // console.log('Received values of form: onsave called >> username>>',checkUserName,email,password)
    onSignup(email, password)
  };
  useEffect(() => {
    setClickCont(clickCount + 1);
    if (
      emailValidation?.userExist?.cognitoTriggerSource ===
      "PreSignUp_SignUp" &&
      emailValidation?.userExist?.valid === true
    ) {
      // setErrorMessage("Email already exists using social login");
      setErrorMessage(
        "This email is already registered with a SkillGigs account. Try another email."
      );
      setCount(true);
      setGreenCheck(false);
      setShowCheckIconEmail(true);
      setTimeout(() => {
        // setCount(false);
        // setGreenCheck(false);
        // setShowCheckIconEmail(false);
        dispatch(checkEmailFlow(false));
      }, 3000);
    } else if (emailValidation?.userExist?.valid === true) {
      setErrorMessage(
        "This email is already registered with a SkillGigs account. Try another email."
      );
      setCount(true);
      dispatch(checkEmailFlow(false));
      setGreenCheck(false);
      setShowCheckIconEmail(true);
      setTimeout(() => {
        // setCount(false);
      }, 3000);
    } else if (
      emailValidation?.userExist?.response?.data?.valid === false &&
      userEmail
    ) {
      dispatch(checkEmailFlow(true));
      // setCheckEmail(true);
    }
  }, [emailValidation]);
  useEffect(() => {
    setCount(false);
  }, [signUpLogin]);
  useEffect(() => {
    // if (Number(clickCount) > 1 && emailValidation?.userExist?.valid) {
    //   dispatch(checkEmailFlow(false));
    // }
    if (props.signinClick) {
      // dispatch(checkEmailFlow(false));
      setCheckEmail(false);
      setUserEmail();
    }
  }, [props.signinClick]);

  const storeAsEmployer = () => {
    try {
      if (window.location.pathname.split("/").includes("employer")) {
        localStorage.setItem("asEmployer", true);
        localStorage.removeItem("asTalent");
      } else {
        localStorage.removeItem("asEmployer");
      }
    } catch {}
  };

  const onSignup = async (email, password) => {
    const U_email = userEmail;
    setLoading(true);
    
    try {
      if (!count) {
        storeAsEmployer()
        const response = await Auth.signUp({
          // username: 'username',
          username: email,
          password,
          attributes: {
            email:email,
            // name: fullname,
            "custom:account_name": null,
            // name: fullname,
            // optional
            // optional - E.164 number convention
            // other custom attributes
          },
        });
        setLoading(false);
        onLogin({ email, password });
        } else {
        // If the username variable is true, execute the catch block
        setLoading(false);
        setTimeout(() => {
          setCount(false);
          form.resetFields();
        }, 3000);
      }
    } catch (error) {
      setLoading(false);
      // setCount(true);
      // setMessageType("container-error");
      // message.error(`${error.message}`);
      setErrorMessage("Email already exists");
      // setCount(true);
      setTimeout(() => {
        setCount(false);
        form.resetFields();
      }, 3000);
      // alert(error.message);
    }
  };
  // useEffect(() => {
  //   const el = document.getElementsByClassName("ant-input");
  //   for (let i = 0; i < el.length; i++) {
  //     el[i].setAttribute("autocomplete", "false");
  //   }
  // }, []);


  return (
    <div className="signup-form">
      <div className="container-auth">
      <Form
              name="normal_login"
              className="login-form"
              initialValues={{
                remember: false,
                email: ''
              }}
              onFinish={emailSave}
              // onFinish={onSignup}
              
            >
              {/* <div className="form-label">Email</div> */}
              <Tooltip placement="topRight" title={textemail} trigger="click">
                <Form.Item
                  name="email"
                  // noStyle={true}
                  rules={[
                    // {
                    //   type: "email",
                    //   message: "Looks like this email is incomplete",
                    // },
                    // {
                    //   required: true,
                    //   message: "Please add your email address",
                    // },
                    {
                      validator: (_, value) => {

                        if (value.length < 1) {
                          setGreenCheck(false)
                          return Promise.reject(new Error("Add an email address"));
                        }

                        // else if (!(/^\w+@[a-zA-Z_]+?\.[a-zA-Z]{2,3}$/.test(value))) {
                        else if (!(/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(value))) {
                          setGreenCheck(false)
                          return Promise.reject(new Error("The email you added doesn't work. Try another"));
                        }
                        // console.log('greencheck',greenCheck);
                        else {
                          setGreenCheck(true)
                          return Promise.resolve();
                        }
                      }
                    }

                  ]}
                >
                  <Input
                    defaultValue={email}
                    // type="email"
                    onChange={(e) => validateEmail(e)}
                    className={`emailInputSignUp 
                    ${greenCheck
                        ? "validInputCSS"
                        : `${showCheckIconEmail ? "notValidInput" : null}`
                      }
                    `}
                    placeholder="Enter your email"
                    suffix={
                      greenCheck ? (
                        <img src={GreenCheck} alt="greenCheck" />
                      ) : (
                        <>
                          {showCheckIconEmail ? (
                            <GoAlert
                              style={{
                                color: "#db2828",
                                marginRight: "0.4rem",
                              }}
                            />
                          ) : null}
                        </>
                      )
                    }
                  />
                </Form.Item>
                {count && (
                  // <Infomessage message={errormessage} class="container-error" />
                  <div style={{ color: 'red' }} >This email is already registered with a SkillGigs account. Try another email.</div>
                )}
              </Tooltip>
              <Form.Item
                name="password"
                // autoComplete="off"
                extra={
                  <div
                    className={`passwordHelp ${greenCheckPassword
                        ? `${null}`
                        : `${showCheckPassword ? "notValidColor" : null}`
                      }`}
                  >
                    Password must be 8 characters or more with a number, uppercase, and lowercase letter.
                  </div>
                }
                rules={[
                  // {
                  //   pattern: /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9]).{8,}$/,
                  // },
                  // {
                  //   required: true,
                  // },
                  {
                    validator: async (_, value) => {
                      if(value == undefined){
                        // console.log('pass val>>>',value)
                        // setGreenCheckPassword(false);
                        // setShowCheckPassword(true)
                        return Promise.reject(new Error("Add password"));
                        // return Promise.reject(new Error("Please enter password"));
                      }
                      if (value.length < 1 || value == undefined) {
                        return Promise.reject(new Error("Add password"));
                      }
                      else {
                        return Promise.resolve();
                      }
                    }
                  }
                ]}
                // help={false}
              >
                <Input.Password
                  autocomplete="new-password"
                  onChange={validatePassword}
                  // type="password"
                  placeholder="Choose a Password"
                  className={`passwordSignUp ${greenCheckPassword
                      ? "validInputCSS"
                      : `${showCheckPassword ? "notValidInput" : null}`
                    }`}
                  iconRender={(visible) =>
                    visible ? (
                      <span
                        style={{
                          fontSize: "12px",
                          fontWeight: 500,
                          fontStretch: "normal",
                          fontStyle: "normal",
                          lineHeight: "normal",
                          letterSpacing: "normal",
                          textAlign: "right",
                          color: "#4054b2",
                        }}
                      >
                        Hide
                      </span>
                    ) : (
                      <span
                        style={{
                          fontSize: "12px",
                          fontWeight: 500,
                          fontStretch: "normal",
                          fontStyle: "normal",
                          lineHeight: "normal",
                          letterSpacing: "normal",
                          textAlign: "right",
                          color: "#4054b2",
                        }}
                      >
                        Show
                      </span>
                    )
                  }
                />
              </Form.Item>
              <Form.Item>
                <Button
                  type="primary"
                  htmlType="submit"
                  className="login-form-button"

                  onClick={() => {
                ReactGA.event({
                  category: "User Interaction",
                  action: "Employer Sign Up Button Click",
                  label: "Signup Button",
                });

                    dispatch(
                      userClicked({
                        uuid: uuid,
                        event: EVENTS.SIGN_UP_BUTTON_CLICK,
                    pageType: PAGE_TYPE.SIGNUP,
                    page: PAGE.MODAL,
                    appName: APP_NAME.EMPLOYER,
                    email: email,
                    password: passwordInp,
                    url: window?.location?.pathname,
                    formValidation: (greenCheck && greenCheckPassword) ? true : false
                      })
                    );
                  }}
                  // disabled={loading || !check}
                  // style={{ fontFamily: "SFProText-Bold" }}
                  // disabled={loading}
                  // onClick={!checkUserLoading ? validateEmail : null}
                >
                  <span className="continue-btn" style={{ fontSize: "1rem" }}>{loading ? <LoadingOutlined/>: 'Join SkillGigs'}</span>
                </Button>
                {/* <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    fontSize: "2rem",
                    margin: "1vh 0",
                    color: "#e73959",
                  }}
                >
                  {loading && <LoadingOutlined />}
                </div> */}
              </Form.Item>
            </Form>
        <div className="terms-and-services">
          {`By joining, I agree to SkillGigs`}
          {/* <a className="subTerm" href="/terms">
            <u>Terms of services</u>
          </a> */}
          <a
            className="subTerm"
            onClick={() => {
              ReactGA.event({
                category: "User Interaction",
                action:
                  APP_NAME.EMPLOYER + " " + EVENTS.TERMS_AND_SERVICES_CLICK,
                label: "Signup Button",
              });

            dispatch(
              userClicked({
                uuid: uuid,
                event: EVENTS.TERMS_AND_SERVICES_CLICK,
                pageType:PAGE_TYPE.SIGNUP,
                page:PAGE.MODAL,
                appName:APP_NAME.EMPLOYER,
                url:window?.location?.pathname
              })
            );
          }} href="https://skillgigs.com/terms-of-service/">
            <u>Terms of services</u>
          </a>
        </div>
      </div>
    </div>
  );
};
export default SignUp;